var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-qrcode"},[_c('canvas',{attrs:{"id":"prodInfoQrcode","width":"180","height":"180"}}),_c('p',[_vm._v("中国工品码")])])
}]

export { render, staticRenderFns }